import React from 'react';
import {MainView, BorderHeaderBox, FILogo, NoteBlock} from '../components/components.js';

class AppConfiguration extends React.Component {

	constructor(props) {
		super(props);

		this.getZipData = this.getZipData.bind(this);

		this.state = {zipData : {data: {}, dataError : false}};
	}

	componentDidMount() {
		if(Object.keys(this.state.zipData.data).length === 0 && this.state.zipData.dataError === false) {
			this.getZipData();
		}
	}

	getZipData() {
		var comp = this;
		var callback = function(response) {
			if(response.code === 200) {
				comp.setState({zipData : {data: response.data, dataError: false}});
			}
			else {
				comp.setState({zipData : {data: {}, dataError: response.detail}});
			}
		};

		window._fiSponsor.getZipData(callback);
	}

	render() {

		window._fiSponsor.loadSessionInfo();

		var content = "Loading data...";

		if(Object.keys(this.state.zipData.data).length) {
			const greenColor = '#9ecf5d';

			var rewardBoxContent = (
				<div className="ContentColumn">
					<div className="ContentRow">
						<div className="SmallFont">Max reward</div>
						<div className="LargeFont">{'$9.99'}</div>
					</div>
					<div className="ContentRow">
						<div className="SmallFont">Max penalty</div>
						<div className="LargeFont">{'$19.98'}</div>
					</div>
				</div>
				);
			var rewardBox = (
				<BorderHeaderBox label={'Rewards'} borderColor={greenColor} content={rewardBoxContent} size={{width: '35vmin', height: 'auto'}} />
				);

			var zipcodesTableContent = [];

			var zipData = this.state.zipData.data.zipData;

			for(var zip in zipData) {
				var tableRow = (
					<tr key={zip} ><td>{zipData[zip].postalcode}</td><td>{zipData[zip].county}</td></tr>
					);

				zipcodesTableContent.push(tableRow);
			}

			var zipContent = (
				<table className="PlinqitConfiguration">
					{zipcodesTableContent}
				</table>
				);

			var zipBox = (
				<BorderHeaderBox label={'Zipcodes'} borderColor='#9a9b9d' content={zipContent} size={{width: '35vmin', height: 'auto'}} />

				);

			const end_date = (typeof window._fiSponsor.sponsors[0].promotions !== 'undefined' && window._fiSponsor.sponsors[0].promotions) ? window._fiSponsor.sponsors[0].promotions.end_date : '1900-01-01';
			const promo_value = (typeof window._fiSponsor.sponsors[0].promotions !== 'undefined' && window._fiSponsor.sponsors[0].promotions) ? window._fiSponsor.sponsors[0].promotions.promo_value : '0';
			
			var promoEndDate = new Date(end_date);
			var promoEndDateOptions = { year: 'numeric', month: 'short', day: 'numeric' };

			var signUpBonusContent = [];

			if(promo_value === '0') {
				signUpBonusContent.push((
					<div className="ContentRow">
						<div className="SmallFont">Sign up bonus</div>
						<div className="LargeFont">No active offer</div>
					</div>

					));
			}
			else {
				signUpBonusContent.push((
					<div className="ContentRow">
						<div className="SmallFont">Sign up bonus</div>
						<div className="LargeFont">{'$' + promo_value}</div>
					</div>

					));

				signUpBonusContent.push((
					<div className="ContentRow">
						<div className="SmallFont">Sign up bonus valid until</div>
						<div className="MedFont">{promoEndDate.toLocaleDateString('en-US', promoEndDateOptions)}</div>
					</div>
					));
			}
			var promosBoxContent = (
				<div className="ContentColumn">
					<div className="ContentRow">
						<div className="SmallFont">Invite friend bonus</div>
						<div className="LargeFont">{'$' + window._fiSponsor.sponsors[0].referral_promo_value}</div>
					</div>
					<div className="ContentRow">
						<div className="SmallFont">Max # of friend invites</div>
						<div className="LargeFont">{window._fiSponsor.sponsors[0].referral_promo_limit}</div>
					</div>
					{signUpBonusContent}
				</div>

				);

			var promoBox = (
				<BorderHeaderBox label={'Promotions'} borderColor={greenColor} content={promosBoxContent} size={{width: '35vmin', height: 'auto'}} />
				);

			var logoBoxContent = (
				<div className="DarkGray">
					<FILogo class="NavBar-FILogo" size={{width: '80%', height: 'auto'}} />
				</div>
				);
			var logoBox = (
				<BorderHeaderBox label={"Sponsor logo"} borderColor='#43b6e6' content={logoBoxContent} size={{width: '35vmin', height: 'auto'}} />
				);

			content = (
				<div><NoteBlock note={"This view is currently READ ONLY. If you need help modifying an aspect of your Plinqit Configuration, please contact support@plinqit.com."} /><br />
				<div className="PlinqitConfiguration-Row">
					<div className="PlinqitConfiguration-Column">
						{rewardBox}
						{zipBox}
					</div>
					<div className="PlinqitConfiguration-Column">
						{promoBox}
						{logoBox}
					</div>
				</div>
				</div>
				);
		}
		

		return (
			<MainView location="App Configuration" amount={window._fiSponsor.sponsors[0].total_saved} content={content} />
			);

	}

}


export default AppConfiguration;